import { KroButton } from "features/components/buttons/kroButton";
import { cn } from "common/utils/utils";
import Routes from "router/routes";
const CampaignSuspendedPage = ({ className }: { className?: string }) => {
  return (
    <div
      className={cn(
        "flex h-screen flex-col items-center justify-center text-center",
        className,
      )}
    >
      <img src={"/assets/icons/suspended.svg"} alt="suspended campaign" />
      <p className="mt-3 text-[24px] font-medium leading-[120%] tracking-[-1.5%] text-neutral-900">
        Campaign under review
      </p>
      <span className="mt-2 font-inter text-[16px] font-normal leading-[24px] tracking-[-1.5%] text-neutral-700">
        This campaign is currently under review.
      </span>
      <span className="mt-1 font-inter text-[16px] font-normal leading-[24px] tracking-[-1.5%] text-neutral-700">
        Please contact the fundraiser. If you're the fundraiser reach out at{" "}
        <span className="font-medium underline decoration-solid">
          support@giv.ng
        </span>
      </span>
      <KroButton
        title="Go Home"
        className="mt-5"
        onclick={() => (window.location.href = Routes.HOME)}
      ></KroButton>
    </div>
  );
};

export default CampaignSuspendedPage;
